import { render, staticRenderFns } from "./SharedEndingFields.vue?vue&type=template&id=cd00fa10"
import script from "./SharedEndingFields.vue?vue&type=script&lang=js"
export * from "./SharedEndingFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports